var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3896 6.55494C15.3913 6.53885 15.3923 6.52249 15.3923 6.50599V4.9883C15.3923 2.23773 12.9733 0 10 0C7.02665 0 4.60768 2.23773 4.60768 4.9883V6.50599C4.60768 6.52249 4.60872 6.53885 4.61037 6.55494C3.90373 6.56944 3.33337 7.10472 3.33337 7.7618V17.1251C3.33337 17.7913 3.91933 18.3333 4.63947 18.3333H15.3606C16.0808 18.3333 16.6667 17.7913 16.6667 17.1251V7.76187C16.6666 7.10472 16.0963 6.56944 15.3896 6.55494ZM5.72712 4.9883C5.72712 2.80885 7.64387 1.03563 9.99993 1.03563C12.356 1.03563 14.2727 2.80885 14.2727 4.9883V6.50599C14.2727 6.52207 14.2738 6.53788 14.2754 6.55356H5.72458C5.72615 6.53782 5.72719 6.52207 5.72719 6.50599V4.9883H5.72712ZM15.5471 17.1252C15.5471 17.2187 15.4617 17.2978 15.3605 17.2978H4.6394C4.53827 17.2978 4.45281 17.2187 4.45281 17.1252V7.76187C4.45281 7.66831 4.53827 7.58926 4.6394 7.58926H15.3605C15.4617 7.58926 15.5471 7.66831 15.5471 7.76187V17.1252Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.16663,
    y: 10.8333,
    width: 1.66667,
    height: 2.5,
    rx: 0.833333,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.9ffaa23f4a33c15eb4a4f8303f5a0be5c7460de47d9cd505cb43ee7bfc929bbf.svg";
export { ForwardRef as ReactComponent };